import hanapin from "../assets/images/hanapin.png";
import emimaru from "../assets/images/emimaru.png";
import shanghaisakura from "../assets/images/shanghaisakura.png";

export const characterImages = {
  hanapin: {
    image: hanapin,
  },

  emimaru: {
    image: emimaru,
  },

  sakura: {
    image: shanghaisakura,
  },
};